import React from "react";
import { Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class NumberComponent extends React.Component {
  constructor(props) {
    super(props);
    this.inputId = `${Math.round(Math.random() * 10 ** 10)}`;
    this.state = {
      data: JSON.parse(JSON.stringify(this.props)),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ data: this.props });
    }
  }

  onChangeData = e => {
    // console.debug("onChangeData", e, this.state.data);
    const data = { ...this.state.data };
    data.value = e.target.value;
    this.setState(() => ({ data }));
  };

  render() {
    // console.debug("this.state.data", this.state.data);
    const { id, value, editable, isPopUp } = this.state.data;
    return (
      <React.Fragment>
        {isPopUp ? (
          <Tooltip placement="top" overlay={<div />}>
            <div
              className="ispopup"
              role="button"
              tabIndex={value}
              onKeyPress={() => this.props.openPopup(value)}
              onClick={() => this.props.openPopup(value)}>
              {value}
              <span className="tilde">
                <FontAwesomeIcon icon={["far", "tilde"]} />
              </span>
            </div>
          </Tooltip>
        ) : (
          <input
            id={id || this.inputId}
            type="number"
            value={value}
            disabled={!editable}
            onChange={e => this.onChangeData(e)}
            onBlur={() =>
              this.props.onBlurData(parseFloat(this.state.data.value))
            }
            data-test="numbercomponent-input"
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGridTypeComponents/NumberComponent.js